<template>
    <div class="inline-block w-full">
        <div class="relative" @click="$emit('click')"
             :class="{'border-b border-error-500': this.error}">
            <slot></slot>
            <div class="absolute right-0 inset-y-0 cursor-pointer" v-if="$slots.icon">
                <div class="table h-full">
                    <div class="table-cell align-middle pr-1">
                        <slot name="icon"></slot>
                    </div>
                </div>
            </div>
            <transition name="grow">
                <div class="absolute bottom-0 w-full bg-primary active-border" v-show="!error && line && active"></div>
            </transition>
        </div>
        <div class="text-right text-sm">{{ helper }}</div>
    </div>
</template>
<script>
export default {
    props: {
        disabled: Boolean,
        helper: String,
        active: Boolean,
        line: {
            type: Boolean,
            default: true
        },
        error: {
            type: Boolean,
            default: false
        }
    }
};
</script>
<style lang="scss" scoped>
$border-size: 2px;

.active-border {
    height: $border-size;
    left: 50%;
    transform: translateX(-50%) translateY($border-size);
}

.grow-enter,
.grow-leave-to {
    width: 0px;
}

.grow-enter-active,
.grow-leave-active {
    transition: width 0.2s linear;
}

.grow-enter-to,
.grow-leave {
    width: 100%;
}

::-webkit-credentials-auto-fill-button {
    visibility: hidden;
    pointer-events: none;
    position: absolute;
    right: 0;
}
</style>
